module.exports = __webpack_public_path__ + "static/img/expert_edit.d888a11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expert_edit.png
// module id = GKbZ
// module chunks = 52